// To reference this file, add <%= javascript_pack_tag 'application' %> to the appropriate
// layout file, like app/views/layouts/application.html.erb

import Turbolinks from "turbolinks";
import Rails from "rails-ujs";
import { Application } from "stimulus";
import { autoload } from "stimulus/webpack-helpers";

import "components/keyboard_shortcuts";
import "components/verbal_close";

import "./application.css";
import "./hello_vue";

Turbolinks.start();
Rails.start();

// stimulus
const application = Application.start();
const controllers = require.context("../controllers", true, /\.js$/);
autoload(controllers, application);
